import { globalStyle, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { actionBar } from "plos/src/styles/utils.css";

export const squadActionsBarWrapper = style([
  actionBar,
  {
    display: "flex",
    flexWrap: "wrap",
    gap: vars.space.xs,
  },
]);

globalStyle(`${squadActionsBarWrapper} > button`, {
  flexGrow: "1",
  width: "auto",
});
